import React, { useEffect, useState } from "react";
import { checkPasswordPolicy } from "../../services/authService";

export default function PasswordPolicyChecklist({ password }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let active = true;

    async function runValidation() {
      if (!password) {
        setStatus(null);
        return;
      }

      try {
        const result = await checkPasswordPolicy(password);
        if (active) setStatus(result);
      } catch {
        if (active) setStatus(null);
      }
    }

    runValidation();

    return () => {
      active = false;
    };
  }, [password]);

  const Item = ({ ok, label }) => (
    <div style={{ marginBottom: 6 }}>
      <span>{ok ? "✅" : "❌"}</span> {label}
    </div>
  );

  return (
    <div style={{ border: "1px solid #ddd", borderRadius: 8, padding: 16, marginTop: 12 }}>
      <h4 style={{ marginTop: 0 }}>Şifre Kuralları</h4>

      {!status ? (
        <p>Şifre yazıldığında kurallar burada kontrol edilir.</p>
      ) : (
        <>
          <Item ok={!!status.meetsMinPasswordLength} label="Minimum karakter uzunluğu" />
          <Item ok={!!status.containsLowercaseLetter} label="En az bir küçük harf" />
          <Item ok={!!status.containsUppercaseLetter} label="En az bir büyük harf" />
          <Item ok={!!status.containsNumericCharacter} label="En az bir rakam" />
          <Item ok={!!status.containsNonAlphanumericCharacter} label="En az bir özel karakter" />
          <div style={{ marginTop: 8, fontWeight: 700 }}>
            Genel durum: {status.isValid ? "Geçerli" : "Yetersiz"}
          </div>
        </>
      )}
    </div>
  );
}